var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_UTR_NUMBER_REQUEST, updateUtrNumberDataFailure, updateUtrNumberDataSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const updateUtrNumber = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            APIIN.post(`report/admin/utr`, data)
                .then((response) => {
                console.log("API Response", response);
                resolve(response);
            })
                .catch((error) => {
                console.log("API Error", error);
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* createUpdateUtrNumberWorker(action) {
    try {
        const data = yield call(updateUtrNumber, action);
        yield put(updateUtrNumberDataSuccess(data));
    }
    catch (error) {
        yield put(updateUtrNumberDataFailure(error));
    }
}
export function* watchUpdateUtrNumberData() {
    yield takeLatest(UPDATE_UTR_NUMBER_REQUEST, createUpdateUtrNumberWorker);
}
